export default __webpack_public_path__ + "static/media/logo-1984.fa899f9b.svg";